const ballotWithX = "☒";
const ballotBox = "☐";
type CheckboxText = typeof ballotWithX | typeof ballotBox;
export const renderCheckbox = (value: boolean): CheckboxText => {
	return value ? ballotWithX : ballotBox;
};